import type { OpeningHours } from "@majourneys/shared";
import { MapCard } from "./map-card";
import { OpeningHoursCard } from "./opening-hours-card";

export interface LocationAndHoursProps {
  latitude?: number | string | null;
  longitude?: number | string | null;
  place: string;
  hours: OpeningHours | undefined;
}

/**
 * Map and opening hours side by side from md up, stacked on a phone with the
 * map first (where it is comes before when it is open). Either card alone
 * takes the full width: no pin, hours alone; unknown hours, map alone.
 */
export function LocationAndHours({ latitude, longitude, place, hours }: LocationAndHoursProps) {
  const hasMap = !!latitude && !!longitude;
  if (!hasMap && !hours) return null;
  const both = hasMap && !!hours;

  return (
    <div data-testid="location-and-hours" className={both ? "grid grid-cols-1 gap-5 md:grid-cols-2" : "grid grid-cols-1"}>
      {hasMap && <MapCard latitude={latitude!} longitude={longitude!} place={place} />}
      {hours && <OpeningHoursCard hours={hours} />}
    </div>
  );
}
